// Exported methods to browse the models tree
import { currentUser } from "./IUsers";
import { getFromServer, postToServer } from "./CommonFunctions";


// get next level of project tree
// pass the id of an element to get his children
// # or * for first level
// return an array of jsTreeNode
/*
jsTreeNode
{
    id - elementId - string
    text - element name - string
    type - element type - string
    children - has children - bool
    size - file size in bytes - number
    lastUpdate - date of last update - string
    updateBy - user that did the last update = string
    pictureUrl - item image url - string //still not done
    lastVersion - for items show the latest version - string
    idToOpen - for item, ID of the latest version - string
    isFavorite - is the item is currently in favorites - bool
    lastOpened - timestamp of last time the model was opened (for recent only), 0 if no value - double
    idForCollections - id of the model (for both item and version) used for collections item in our DB
}
*/
export async function getNextLevel(id) {
    if (id == "#") id = "*";
    var url = `/api/forge/datamanagement/nextlevel?id=${id}`;
    var res = await getFromServer(url);
    return res;
}

// get user recent list
// return an array of jsTreeNode
export async function getRecent() {
    var url = "/api/forge/userdata/recent";
    var res = await getFromServer(url);
    return res;
}

// Add itemNode to recent
// itemNode is jsTreeNode
export async function addToRecent(itemNode) {
    var url = "/api/forge/userdata/recent";
    postToServer(url, itemNode);
}

// get user favorites list
// return an array of jsTreeNode
export async function getFavorites() {
    var url = "/api/forge/userdata/favorites";
    return await getFromServer(url);
}


// Add itemNode to favorites
// itemNode is jsTreeNode
export async function addToFavorites(itemNode) {
    var url = "/api/forge/userdata/favorites";
    postToServer(url, itemNode);
}


// remove itemNode from favorites
// itemNode is jsTreeNode
export async function removeFromFavorites(itemNode) {
    var url = "/api/forge/userdata/rfavorites";
    postToServer(url, itemNode);
}

// Send integration request for HUB admin
export async function sendIntegrationMail(address) {
    var url = "/api/forge/user/mail";
    var data = [];

    data.push(address);
    data.push(currentUser.userName);

    postToServer(url, data);
}

// Send support request mail
// recieves user email
// true/false if user can't find his company
// message string
export async function sendSupportMail(email, cantFind, message) {
    var url = "/api/forge/user/supportMail";
    var data = [];

    data.push(email);
    data.push(currentUser.userName);
    data.push(cantFind);
    data.push(message);

    postToServer(url, data);
}
